import type { FiringAlert } from '@avslack/shared';

/**
 * Riasztás a valós idejű rétegtől a felugró ablakig.
 *
 * Ugyanaz a minta, mint az emlékeztetőnél: a `RealtimeProvider` és a felugró
 * ablak között nincs szülő-gyerek kapcsolat, és egy ilyen ritka esemény miatt
 * nem éri meg a React-fát átrendezni.
 */
export interface AlertEvent {
  alert: FiringAlert;
  grafanaUrl: string | null;
}

type FiredHandler = (event: AlertEvent) => void;
type ResolvedHandler = (fingerprint: string) => void;

const fired = new Set<FiredHandler>();
const resolved = new Set<ResolvedHandler>();

export function onAlertFired(handler: FiredHandler): () => void {
  fired.add(handler);
  return () => fired.delete(handler);
}

export function onAlertResolved(handler: ResolvedHandler): () => void {
  resolved.add(handler);
  return () => resolved.delete(handler);
}

export function emitAlertFired(event: AlertEvent): void {
  for (const handler of fired) handler(event);
}

export function emitAlertResolved(fingerprint: string): void {
  for (const handler of resolved) handler(fingerprint);
}
